import { render } from "./SiteFocusView.vue?vue&type=template&id=8b062b7e&scoped=true"
import script from "./SiteFocusView.vue?vue&type=script&lang=js"
export * from "./SiteFocusView.vue?vue&type=script&lang=js"

import "./SiteFocusView.vue?vue&type=style&index=0&id=8b062b7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b062b7e"]])

export default __exports__